<template>
  <div class="privacy-policy-view">
    <!-- Header -->
    <Header />

    <!-- Side Navigation -->
    <SideNavigation :sections="sectionsContent" />

    <!-- Main Content Area -->
    <main class="privacy-policy-main">
      <!-- PrivacyPolicyContent provides sections via event -->
      <PrivacyPolicyContent
        @sections-content-updated="updateSectionsContent"
      />
    </main>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import SideNavigation from '@/components/SideNavigation.vue';
import PrivacyPolicyContent from '@/components/PrivacyPolicyContent.vue';

export default {
  name: 'PrivacyPolicyView',
  components: {
    Header,
    SideNavigation,
    PrivacyPolicyContent,
  },
  data() {
    return {
      sectionsContent: [],
    };
  },
  methods: {
    updateSectionsContent(sections) {
      // When PrivacyPolicyContent is mounted, 
      // this event is sent, and we populate 
      // 'sectionsContent' for the SideNavigation
      this.sectionsContent = sections;
    }
  },
};
</script>

<style scoped>
.privacy-policy-view {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #ffffff;
  overflow-x: hidden;
  width: 100%;
  position: relative;
  padding-top: 80px; /* Add space for fixed header */
}

.privacy-policy-main {
  flex: 1;
  padding-top: 0;
  margin-top: 0;
  position: relative;
  width: 100%;
}

/* Desktop Styles */
@media (min-width: 992px) {
  .privacy-policy-main {
    transition: margin-left 0.3s ease;
  }
}

/* Mobile Styles */
@media (max-width: 991.98px) {
  .privacy-policy-main {
    margin-left: 0;
  }
}
</style>